import { VerticalDivider } from "@nokia-csf-uxr/ccfk";
import React, {  } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CONFIG } from "../../config";
import { AccountContext } from "../../contexts/AccountContext";
import { SingleBandLinkReferenceContext, SingleBandLinkUserContext } from "../../contexts/SingleBandLinkContext";
import LoadingScreen from "../LoadingScreen";
import AdvancedPathDetail from "./AdvancedLink/AdvancedPathDetail";
import AnnualOutage from "./AdvancedLink/AnnualOutage";
import PropagationAccuracy from "./SimpleLink/PropagationAccuracy";
import AdditionalLosses from "./SimpleLink/AdditionalLosses";
import AntennaDetails from "./SimpleLink/AntennaDetails";
import EquipmentDetails from "./SimpleLink/EquipmentDetails";
import EquipmentType from "./SimpleLink/EquipmentType";
import LinkName from "./SimpleLink/LinkName";
import MultiPathOutage from "./SimpleLink/MultiPathOutage";
import PathDetails from "./SimpleLink/PathDetails";
import RainOutagePred from "./SimpleLink/RainOutagePred";
import Standard from "./SimpleLink/Standard";
import Container from "react-bootstrap/esm/Container";
import { Alert, Button, ButtonGroup, Col, Form, Modal, Row, ToggleButton } from "react-bootstrap";
import { DualBandLinkUserContext, DualBandLinkReferenceContext } from "../../contexts/DualBandLinkContext";
import DualBandAntennaDetails from "./SimpleLink/DualBandAntennaDetails";
import { isUndefined } from "util";

/**
 * Regex to test a string with REGEX_GPS_COORDS.test("Your string")
 */
export const REGEX_DEGREE_COORDS  =/^([0-9]+)(\s)([0-9]+)(\s)([0-9]+((\.)*([0-9]))*)$/;


/**
 * Component to pass the parameters of the reactjs router
 * The parameter :id which is passed 
 * @returns 
 */
export default function LinkForm(): JSX.Element {
    const { id, dual } = useParams()
    return  <>
        <AccountContext.Consumer>
        {(account) => (
            <LinkFormComponent account={account} linkId={id == "create" ? undefined : id} mode={dual} />
        )}
        </AccountContext.Consumer>
    </>
}

/**
 * LinkFormComponent manages the interaction between single and dual band link form
 */
class LinkFormComponent extends React.Component<any,any> {
    static toastId: any;

    constructor(props: {account: any, linkId:string|undefined, mode: string|undefined}) {
        super(props);

        LinkFormComponent.toastId = React.createRef();
        
        this.state = {
            band: (this.props.mode == "dual" ? 2 : 1), // 1 : single band / 2 : dual band
            commonData: {}, // Common data which are shared between single and dual band form
            loading: true,
            forwardedData: {
                single: {},
                dual: {}
            },
            saved: false
        }        
    }

    componentDidMount(): void {
        let comp = this

        if(comp.props.linkId != null) {
            fetch(CONFIG.apiURI+"/link/"+comp.props.linkId, { 
                method: 'GET',
                mode: "cors",
                headers: {
                    Accept: 'application/json',
                    "token": comp.props.account.token
                }
            })
            .then((res) => res.json())
            .then((jsonUserData) => {

                if(jsonUserData.link != null) {
                    comp.setState({band: jsonUserData.isDualBandLink ? 2 : 1})
                    comp.setState({saved: true})

                    if(jsonUserData.equipDualBandAntenna != null) {
                        jsonUserData["showDualBandAntenna"] = true
                    }

                    jsonUserData["define"] = function(key: string, value: any, callback?: (() => void)) {
                        let result = comp.state.forwardedData[comp.state.band == 2 ? "dual" : "single"]
                        result[key] = value;
                        comp.setState({forwardedData: {[comp.state.band == 2 ? "dual" : "single"]: result}}, callback);
                    }

                    jsonUserData["edit"] = true; // true if we are not editing a link's information which already 
                    if(jsonUserData.isDualBandLink) {
                        comp.setState({"forwardedData": { "dual": jsonUserData}}, () => comp.setState({loading: false}))
                    } else {
                        comp.setState({"forwardedData": { "single": jsonUserData}}, () => comp.setState({loading: false}))
                    }
                    
                }
            })            
        }
    }

    /**
     * Load reference data
     * @param comp Component where link data will be stored
     */
    loadReferenceData(comp: any) {
        let compParent = this;
        // Get the reference data
        fetch(((compParent.state.band == 2) ? CONFIG.apiURI+"/references/dualband" : CONFIG.apiURI+"/references"), { 
            method: 'GET',
            mode: "cors",
            headers: {
                Accept: 'application/json',
                "token": compParent.props.account.token
            }
        })
        .then((res) => {
            if (!res.ok) {
                if ([401, 403].includes(res.status)) {
                    this.props.account.setIsExpired(true)
                    return;
                }
              } 
            return res.json()
        })
        .then((jsonRefData) => {
            /**
             * Create a function in reference data table to update
             * @param key Key 
             * @param value New value
             * @param callb A callback function that is executed at the end
             */
            jsonRefData["define"] = function(key: string, value: any, callb?: (() => void)) {
                let result = comp.state.reference;
                result[key] = value;
                comp.setState({reference: result}, callb);
            }

            let defaultData = {} as any

            console.log("pass condition 1")
            // if state to store user data is already declared, then we add define function, else we declare state
            if(compParent.state.forwardedData[compParent.state.band == 2 ? "dual" : "single"] == null) {
                let singleForwardedDual = false;

                comp.setState({reference: jsonRefData});

                console.log("pass condition 2")

                if(compParent.state.band == 2 && compParent.props.linkId != null) { // probleme ici pour ecraser les données de lien par défaut
                    defaultData = compParent.state.forwardedData["single"]
                    singleForwardedDual = true           
                } else {
                    compParent.loadDefaultData(jsonRefData)
                }

                compParent.setState({forwardedData: { [this.state.band == 2 ? "dual" : "single"]: defaultData}}, () => {
                    defaultData["define"] = function(key: string, value: any, callback?: (() => void)) {
                        let result = compParent.state.forwardedData[compParent.state.band == 2 ? "dual" : "single"]
                        result[key] = value;
                        compParent.setState({forwardedData: {[compParent.state.band == 2 ? "dual" : "single"]: result}}, callback);
                    }
                    
                    compParent.setState({forwardedData: { [this.state.band == 2 ? "dual" : "single"]: defaultData}}, () => {
                        if(singleForwardedDual) {
                            DualBandLinkForm.updatedEquipments(comp.props.account.token, jsonRefData, compParent.state.forwardedData.dual, compParent.state.forwardedData.dual.equipType, "", "2")
                        }
                    })
                })
                // if user data is declared but array is empty, then we load a default link
            } else if(compParent.props.linkId == null && (compParent.state.forwardedData[compParent.state.band == 2 ? "dual" : "single"].length == null || compParent.state.forwardedData[compParent.state.band == 2 ? "dual" : "single"].length == 0)) {
                comp.setState({reference: jsonRefData});

                compParent.loadDefaultData(jsonRefData)

            // When we load a link configuration
            } else {
                comp.setState({reference: jsonRefData}, () => {
                    if(compParent.state.band == 2) {
                        DualBandLinkForm.updatedEquipments(comp.props.account.token, jsonRefData, compParent.state.forwardedData.dual, compParent.state.forwardedData.dual.equipType, "", "2")
                    }
                });
            }
        })
    }

    /**
     * Load default data
     * @param refData Reference data
     */
    loadDefaultData(refData: any) {
        let comp = this;
        let defaultStandard = 1;

        comp.props.account.roles?.forEach((role:string) => {
            if(role.includes("ansi")) {
                defaultStandard = 2;
                return;
            }
        });

        fetch(CONFIG.apiURI+"/default/"+(this.state.band == 1 ? "" : "dualband/")+defaultStandard, { 
            method: 'GET',
            mode: "cors",
            headers: {
                Accept: 'application/json',
                "token": comp.props.account.token
            }
        })
        .then((res) => {
            if (!res.ok) {
                return;
            } 
            return res.json()
        })
        .then((jsonUserData) => {

            if(jsonUserData.equipDualBandAntenna != null) {
                jsonUserData["showDualBandAntenna"] = true
            }

            jsonUserData["define"] = function(key: string, value: any, callback?: (() => void)) {
                let result = comp.state.forwardedData[comp.state.band == 2 ? "dual" : "single"];
                result[key] = value;
                comp.setState({forwardedData: {[comp.state.band == 2 ? "dual" : "single"]: result}}, callback);
            }

            jsonUserData["edit"] = true; // We set edit on true, then false to display loaded values in field input

            comp.setState({
                "forwardedData": {
                    [jsonUserData.isDualBandLink ? "dual" : "single"]: jsonUserData
                }
            }, () => {

                // Filter equipment types for the second band when an user is creating a new dual band link
                if(comp.state.band == 2) { 
                    DualBandLinkForm.updatedEquipments(comp.props.account.token, refData, jsonUserData, jsonUserData.equipType, "", "2")
                }

                comp.setState({
                    "forwardedData": {
                        [jsonUserData.isDualBandLink ? "dual" : "single"]: {...jsonUserData, edit: false}
                    }
                })
                comp.setState({loading: false})
            })
        })
    }

    /**
     * Notification for waiting the end of the save
     * @returns 
     */
    notify() { 
        LinkFormComponent.toastId.current = toast.loading(CONFIG.sentences["create_link.popup.saving_in_progress"], 
        { 
            position: "bottom-right", 
            autoClose: false 
        });
    }
  
    /**
     * Notification for missing parameter(s)
     * @param msg 
     */
    missingParameters(msg?: string) {
        toast((msg == null ? CONFIG.sentences["create_link.popup.missing_parameters"] : msg), 
        {
            position: "bottom-right",
            type: toast.TYPE.WARNING, 
            autoClose: 2500 
        })
    }

    /**
     * Notification to inform the successful save
     */
    successfulSaving() {
        toast.update(LinkFormComponent.toastId.current, {
            render: CONFIG.sentences["create_link.popup.saving"], 
            position: "bottom-right",
            type: toast.TYPE.SUCCESS,
            isLoading: false,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
            autoClose: 5000 
        })      
    }
  
    /**
     * Notification to inform that an error has been encountered during the save
     */
    errorSaving() {
        toast.update(LinkFormComponent.toastId.current, {
            render: CONFIG.sentences["create_link.popup.error"], 
            position: "bottom-right",
            type: toast.TYPE.ERROR, 
            isLoading: false,
            autoClose: 5000 
        })
    }
  
    /**
     * Check if space diversity is enabled
     * @param link 
     * @returns 
     */
    sdIsEnabled(link: any, bandItem: string) {
        for (let i = 0; i < link["equipConf"+bandItem]?.features?.length; i++) {
            if(link["equipConf"+bandItem]?.features[i].idFeature == 4 && link?.equipConf?.features[i].mandatory) {
                return true;
            }
        }
        return link["features"+bandItem]?.includes("4")
    }

    /**
     * Load shared data in the current form
     * @param comp Component where are stored data (Simple or dual band form)
     */
    loadSharedData(comp: any) {
        comp.setState({
            user: {
                ...comp.state.user, 
                ...this.state.commonData
            }
        })
    }

    /**
     * Switch between single and dual band (two-way)
     * @param band the band that user wants selected
     * @returns 
     */
    switchBand(band: number) {
        // If the user changes the number of bands for an exisiting link, then a warning message will be displayed
        if(this.state.user?.edit && this.state.user?.isDualBandLink && band == 1) {
            this.setState({"warning": true})
        } else if(this.state.user?.edit && this.state.user?.isDualBandLink && band == 2) {
            this.setState({"warning": false})
        }

        if(this.state.band != band) {    
            this.setState({band: band})
        }
    }

    debug(val: any) {
        console.log("debug linkform")
        console.log(val)
    }

    /**
     * Root of the form
     * @returns 
     */
    render() {
        return (
            <>
                <LoadingScreen displayed={this.state.loading} />               
                <Container className='mt-3'>
                    <Row>
                        <Col>
                            <Button className="menu-button" bsPrefix="" variant="secondary" onClick={() => window.location.href = "/"}>My links</Button>
                            <Button className="menu-button-active ms-2" bsPrefix="" variant="secondary">Link configuration</Button>
                            <Button className={!window.location.href.includes("create") ? "menu-button ms-2" : "hide-input"} bsPrefix="" variant="secondary" onClick={() => window.location.href = "/link/"+window.location.href.substring(window.location.href.lastIndexOf('/')+1)+"/budget"}>Link budget</Button>                            
                            <Button className={!window.location.href.includes("create") && (this.state.band == 1)  ? "menu-button ms-2" : "hide-input"} bsPrefix="" variant="secondary" onClick={() => window.location.href = "/link/"+window.location.href.substring(window.location.href.lastIndexOf('/')+1)+"/boq"}>Link BoM</Button>
                            {/*<Button className={!window.location.href.includes("create") ? "menu-button ms-2" : "hide-input"} bsPrefix="" variant="secondary" onClick={() => window.location.href = "/link/"+this.props.linkId+"/budget"}>Link budget</Button>*/}
                            {/*<Button className={!window.location.href.includes("create") ? "menu-button ms-2" : "hide-input"} bsPrefix="" variant="secondary" onClick={() => window.location.href = "/link/"+this.props.linkId+"/boq"}>Link BoM</Button>*/}
                        </Col>
                    </Row>
                    <br></br>
                    <Row>
                        <Col>
                            <Container>
                                <Row>
                                { this.state.warning ? 

                                    <>
                                        <Alert key='warning' variant='warning'>
                                        Your current link is a dual band, if you save this one in single band <Alert.Link href="#">the data will be deleted !</Alert.Link>
                                        </Alert>
                                    </>

                                    :
                                    <></>
                                }
                                    <ButtonGroup>
                                        <ToggleButton
                                            type="radio"
                                            name="radio"
                                            value={2}
                                            className={this.state.band != 1 ? "action-button unselected-bnt btn btn-primary" : "action-button btn btn-primary"}
                                            checked={this.state.band == 1 }
                                            onClick={(e) => this.switchBand(1)}
                                        >
                                            Single band
                                        </ToggleButton>

                                        <ToggleButton
                                            type="radio"
                                            name="radio"
                                            value={2}
                                            className={this.state.band != 2 ? "action-button unselected-bnt btn btn-primary" : "action-button btn btn-primary"}
                                            checked={this.state.band == 2 }
                                            onClick={(e) => this.switchBand(2)}
                                        >
                                            Dual band
                                        </ToggleButton>
                                    </ButtonGroup>
                                </Row>
                            </Container>
                        </Col>
                    </Row>

                    <>
                    { this.debug(this.state.forwardedData) }
                    </>

                    {this.state.band == 1 ? 
                        <SingleBandLinkForm
                        forwardedData={this.state.forwardedData?.single}
                        loadReferenceData={(comp:any) => this.loadReferenceData(comp)}
                        account={this.props.account}
                        linkId={this.props.linkId}
                        notify={this.notify} 
                        missingParameters={this.missingParameters} 
                        successfulSaving={this.successfulSaving} 
                        errorSaving={this.errorSaving}
                        sdIsEnabled={this.sdIsEnabled} />
                        : 
                        <DualBandLinkForm
                        forwardedData={this.state.forwardedData?.dual}
                        loadReferenceData={(comp:any) => this.loadReferenceData(comp)}
                        account={this.props.account}
                        notify={this.notify} 
                        missingParameters={this.missingParameters} 
                        successfulSaving={this.successfulSaving} 
                        errorSaving={this.errorSaving}
                        sdIsEnabled={this.sdIsEnabled} /> 
                    }

                </Container>
            </>
        )
    }

}

/**
 * Single band link form
 */
export class SingleBandLinkForm extends React.Component<any,any> {
    constructor(props: { loadReferenceData: any, forwardedData: any, account?: Readonly<any>, linkId?: string, notify: any, missingParameters: any, successfulSaving: any, errorSaving: any, sdIsEnabled: any}) {
        super(props);
        this.state = {
            reference: {},
            confirmSwitch: false // if true then the modal is displayed
        }

    }

    componentDidMount(): void {
        this.props.loadReferenceData(this)
    }

/**
 * Set the rain rate according to geographical coordinates
 * @param token 
 * @param linkInput 
 */
    setManualRainRate(token: string, linkInput: any){
        let comp = this;

        let formData = new FormData();
        
        try{
            if (linkInput.prop_accuracy == "advanced") {
                if (linkInput.site1_coords.longitude != undefined
                    && linkInput.site1_coords.longitude_direction != undefined
                    && linkInput.site1_coords.latitude != undefined
                    && linkInput.site1_coords.latitude_direction != undefined
                    && linkInput.site2_coords.longitude != undefined
                    && linkInput.site2_coords.longitude_direction != undefined
                    && linkInput.site2_coords.latitude != undefined
                    && linkInput.site2_coords.latitude_direction != undefined){                      

                    formData.append("site1_long", linkInput.site1_coords.longitude);
                    formData.append("site1_long_side", linkInput.site1_coords.longitude_direction);
                    formData.append("site1_lat", linkInput.site1_coords.latitude);
                    formData.append("site1_lat_side", linkInput.site1_coords.latitude_direction);

                    formData.append("site2_long", linkInput.site2_coords.longitude);
                    formData.append("site2_long_side", linkInput.site2_coords.longitude_direction);
                    formData.append("site2_lat", linkInput.site2_coords.latitude);
                    formData.append("site2_lat_side", linkInput.site2_coords.latitude_direction);
                    
                    formData.append("site_length", linkInput.site_length);
                    formData.append("prop_accuracy", linkInput.prop_accuracy);

                    formData.append("rainRateNorm", linkInput.rainRateNorm.idRainRateNorm);
                    formData.append("annualOutageNorm", linkInput.annualOutageNorm.idAnnualOut);
                    
                    if(linkInput.annualOutageNorm.idAnnualOut == 2) {
                        formData.append("avg_tmp", linkInput?.avg_tmp == null ? 0 : linkInput?.avg_tmp);
                        formData.append("tempUnit", linkInput?.tempUnit.idTempUnit);
                    }

                    formData.append('name', linkInput.edit ? linkInput.link.name : linkInput.name);
                    formData.append('site1', linkInput.site1);
                    formData.append('losses_site1', linkInput.losses_site1 != undefined ? linkInput.losses_site1 : 0);
                    formData.append('site2', linkInput.site2);
                    formData.append('losses_site2', linkInput.losses_site2 != undefined ? linkInput.losses_site2 : 0);
                    formData.append('linkType', "1"); // Simple link
                    formData.append('margin', linkInput.margin != undefined ? linkInput.margin : 0);
                    formData.append('distanceUnit', linkInput.distanceUnits.idDistUnit);
                    formData.append('equipAntennaSite1', linkInput.equipAntennaSite1.idAntenna);
                    formData.append('equipAntennaSite2', linkInput.equipAntennaSite2.idAntenna);
        
                    if(this.props.sdIsEnabled(linkInput, "")) {
                        formData.append('equipAntennaSite1Div', linkInput.equipAntennaSite1Div.idAntenna);
                        formData.append('equipAntennaSite2Div', linkInput.equipAntennaSite2Div.idAntenna);
                    }
        
                    formData.append('equipBandw', linkInput.equipBandw.idChannelBdw);
                    formData.append('equipConf', linkInput.equipConf.idConf);
                    formData.append('equipFreq', linkInput.equipFreq.idFreq);
                    formData.append('equipMod', linkInput.equipMod.idMod);
        
                    if(linkInput.features.includes("7")) {
                        formData.append('equipModMax', linkInput.equipModMax.idMod);
                    }
        
                    formData.append('equipNorm', linkInput.equipNorms.idEquipNorm);
                    formData.append('equipType', linkInput.equipType.idEquip);

                    let features = linkInput.features == undefined ? [] : linkInput.features;
                    for (let i = 0; i < linkInput.equipConf.features.length; i++) {
                        const e = linkInput.equipConf.features[i];
                        if(e.mandatory) {
                            if(!features.includes(e.idFeature.toString())) {
                                features.push(e.idFeature.toString());
                            }
                        }
                    }       
                    formData.append('features', features);
        
                    formData.append('rainOutagePred', linkInput.rainOutageNorm.idRainOutPred);
                    
                    formData.append('multipathOutagePreds', linkInput.multipathOutagePreds.idPropCond);
                    formData.append('multipathOutageNorm', linkInput.multipathOutageNorm.idMultiPathOutPred);
        
                    if(linkInput.tx_power != null) {
                        formData.append('tx_power', linkInput.tx_power);
                    }
               
                    if(linkInput.rainOutageNorm.idRainOutPred == 2) { // 2 is Crane
                        formData.append('craneZone', linkInput.craneZone.idCraneZone);
                    } else {
                        formData.append('rainRate', linkInput.rainRate.val);
        
                        fetch(CONFIG.apiURI+"/link/rainrate", { 
                            method: 'POST',
                            mode: "cors",
                            headers: {
                                Accept: 'application/json',
                                "token": token
                            },
                            body: formData
                        })
                        .then((res) => res.json())
                        .then((json) => {
                            if (json != null) {
                                let rainRate = {
                                    val : parseInt(json)
                                }
                                linkInput.define("rainRate", rainRate);
                            }
                        })
                    }                            
                }
            }
        }
        catch{

        }
    }

    /**
     * Send the data to server
     * @param token The token generated for the user
     * @param linkInput Data of the user has defined in the form
     */
    onSend(token: string, linkInput: any, saveAs: boolean) {
        let formData = new FormData();

        try {
            formData.append("prop_accuracy", linkInput.prop_accuracy);
            if(linkInput.prop_accuracy == "advanced") {
                formData.append("site1_long", linkInput.site1_coords.longitude);
                formData.append("site1_long_side", linkInput.site1_coords.longitude_direction);
                formData.append("site1_lat", linkInput.site1_coords.latitude);
                formData.append("site1_lat_side", linkInput.site1_coords.latitude_direction);

                formData.append("site2_long", linkInput.site2_coords.longitude);
                formData.append("site2_long_side", linkInput.site2_coords.longitude_direction);
                formData.append("site2_lat", linkInput.site2_coords.latitude);
                formData.append("site2_lat_side", linkInput.site2_coords.latitude_direction);

                formData.append("fadefactor", linkInput.fadefactor != undefined ? linkInput.fadefactor : 0);

                if(linkInput.rainOutageNorm.idRainOutPred == 1) {
                    if(linkInput.rainRateNorm.idRainRateNorm == null) {
                        throw new Error("Rain rate standard must be selected !")
                    }
                }

                formData.append("rainRateNorm", linkInput.rainRateNorm.idRainRateNorm);
                formData.append("annualOutageNorm", linkInput.annualOutageNorm.idAnnualOut);
                
                if(linkInput.annualOutageNorm.idAnnualOut == 2) {
                    formData.append("avg_tmp", linkInput?.avg_tmp == null ? 0 : linkInput?.avg_tmp);
                    formData.append("tempUnit", linkInput?.tempUnit.idTempUnit);
                } else if (linkInput.annualOutageNorm.idAnnualOut == null) {
                    throw new Error("Annual outages methodology must be selected !")
                }
            }

            if((linkInput?.edit && linkInput?.link?.name?.length == 0) || linkInput?.name?.length == 0) {
                alert("Please, define a name for your configuration !");
                return;
            }
            
            formData.append('name', linkInput.edit ? linkInput.link.name : linkInput.name);
            formData.append('site_length', (Math.round(linkInput.site_length * 100) / 100).toString());
            formData.append('site1', linkInput.site1);
            formData.append('losses_site1', linkInput.losses_site1 != undefined ? linkInput.losses_site1 : 0);
            formData.append('site2', linkInput.site2);
            formData.append('losses_site2', linkInput.losses_site2 != undefined ? linkInput.losses_site2 : 0);
            formData.append('linkType', "1"); // Simple link
            formData.append('margin', linkInput.margin != undefined ? linkInput.margin : 0);
            formData.append('distanceUnit', linkInput.distanceUnits.idDistUnit);
            formData.append('equipAntennaSite1', linkInput.equipAntennaSite1.idAntenna);
            formData.append('equipAntennaSite2', linkInput.equipAntennaSite2.idAntenna);

            if(this.props.sdIsEnabled(linkInput, "")) {
                formData.append('equipAntennaSite1Div', linkInput.equipAntennaSite1Div.idAntenna);
                formData.append('equipAntennaSite2Div', linkInput.equipAntennaSite2Div.idAntenna);
            }

            formData.append('equipBandw', linkInput.equipBandw.idChannelBdw);
            formData.append('equipConf', linkInput.equipConf.idConf);
            formData.append('equipFreq', linkInput.equipFreq.idFreq);
            formData.append('equipMod', linkInput.equipMod.idMod);

            if(linkInput.features.includes("7")) {
                formData.append('equipModMax', linkInput.equipModMax.idMod);
            }

            formData.append('equipNorm', linkInput.equipNorms.idEquipNorm);
            formData.append('equipType', linkInput.equipType.idEquip);

            let features = linkInput.features == undefined ? [] : linkInput.features;
            for (let i = 0; i < linkInput.equipConf.features.length; i++) {
                const e = linkInput.equipConf.features[i];
                if(e.mandatory) {
                    if(!features.includes(e.idFeature.toString())) {
                        features.push(e.idFeature.toString());
                    }
                }
            }

            // Check if required features are selected
            if(!(features.includes("1") || features.includes("2"))) {
                alert("Please, select a polarization !");
                throw "Erreur !";
            } else if(!(features.includes("5") || features.includes("6"))) {
                alert("Please, select a polarization !");
                throw "Erreur !";
            }

            formData.append('features', features);

            if(linkInput?.prop_accuracy == "advanced") {
                let valid = false;
                if(!(linkInput?.site1_coords?.latitude_direction == "S" || linkInput?.site1_coords?.latitude_direction == "N")) {
                    alert("Longitude site 1 is invalid !");
                    throw "Erreur !";
                }

                if(!(linkInput?.site2_coords?.latitude_direction == "S" || linkInput?.site2_coords?.latitude_direction == "N")) {
                    alert("Longitude site 2 is invalid !");
                    throw "Erreur !";
                }

                if(!(linkInput?.site1_coords?.longitude_direction == "E" || linkInput?.site1_coords?.longitude_direction == "W")) {
                    alert("Latitude site 1 is invalid !");
                    throw "Erreur !";
                }

                if(!(linkInput?.site2_coords?.longitude_direction == "E" || linkInput?.site2_coords?.longitude_direction == "W")) {
                    alert("Latitude site 2 is invalid !");
                    throw "Erreur !";
                }

                if(!REGEX_DEGREE_COORDS.test(linkInput?.site1_coords?.longitude)) {
                    alert("The coordinates of the site 1 are invalid !");
                    throw "Erreur !";
                }

                if(!REGEX_DEGREE_COORDS.test(linkInput?.site2_coords?.longitude)) {
                    alert("The coordinates of the site 2 are invalid !");
                    throw "Erreur !";
                }
            }


            if(linkInput.rainOutageNorm.idRainOutPred == 2) { // 2 is Crane
                formData.append('craneZone', linkInput.craneZone.idCraneZone);
            } else {
                if(linkInput.rainRate.val == 0 || linkInput.rainRate.val == null) {
                    throw new Error("Rain rate must be upper than 0 !")
                }
                formData.append('rainRate', linkInput.rainRate.val);
            }

            if(linkInput.rainOutageNorm.idRainOutPred == null) {
                throw new Error("Rain rate standard must be selected !")
            }

            formData.append('rainOutageNorm', linkInput.rainOutageNorm.idRainOutPred);
            
            formData.append('multipathOutagePreds', linkInput.multipathOutagePreds.idPropCond);
            formData.append('multipathOutageNorm', linkInput.multipathOutageNorm.idMultiPathOutPred);

            if(linkInput.tx_power != null) {
                formData.append('tx_power', linkInput.tx_power);
            }

            this.props.notify();

            // if a dual band link switch to a single band link then true else false
            let replace = (linkInput.edit && linkInput.isDualBandLink)
            if(replace) {
                formData.append('replace', replace);
            }

            fetch(CONFIG.apiURI+"/link"+((linkInput.edit && saveAs == false) ? "/"+linkInput.link.idLink : ""),
            { 
                method: 'POST',
                mode: "cors",
                headers: {
                    Accept: 'application/json',
                    "token": token
                },
                body: formData
            }
            ).then((response) => response.json())
            .then((data) => {
                this.props.successfulSaving();
                linkInput.define('link', {
                    idLink: data.idLink,
                    lastUpdate: data.lastUpdate,
                    name: data.name
                });
                linkInput.define('edit', true);
                window.history.replaceState('', '', saveAs == true ? "/link/"+data.idLink : "/link/"+linkInput.link.idLink);
            })
            .catch((error) => {
                this.props.errorSaving();
            });
        } catch(e: any) {
            if(e.message.includes("is undefined")) { // if the error is a default message
                this.props.missingParameters()
            } else {
                this.props.missingParameters(e.message)
            }
        }

    }

    render() {
        return <>
            <SingleBandLinkUserContext.Provider value={this.props.forwardedData == undefined ? {} : this.props.forwardedData}>
                <SingleBandLinkReferenceContext.Provider value={this.state.reference}>
                    <Container className='mt-3'>
                        <Row>
                            <Col>
                                <Container>
                                    <Row>
                                        <h5 className="h5">GENERAL</h5>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Standard band={1}></Standard>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <LinkName band={1}></LinkName>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <PropagationAccuracy band={1}/>
                                        </Col>
                                    </Row>
                                    <SingleBandLinkUserContext.Consumer>
                                        {(link) => (
                                        <>
                                        
                                            <h5 className="h5 mt-3">SITES</h5>
                                            <div>
                                                { link.prop_accuracy == "advanced" ? <AdvancedPathDetail band={1} onChange={() => this.setManualRainRate(this.props.account.token, link)}/> : <PathDetails band={1}/>}
                                            </div>
                                            <h5 className="h5 mt-3">PROPAGATION CONDITIONS</h5>
                                            <MultiPathOutage band={1}/>
                                            <h5 className="h5 mt-3">RAIN OUTAGE PREDICTIONS</h5>
                                            <RainOutagePred band={1}/>
                                            { link.prop_accuracy == "advanced" ?
                                            <>
                                            <h5 className="h5 mt-3">ANNUAL OUTAGES</h5>
                                            <AnnualOutage band={1} /> 
                                            </> 
                                            : 
                                            <></> }
                                        </>
                                    )}
                                    </SingleBandLinkUserContext.Consumer>
                                </Container>
                            </Col>
                            <Col xs lg="1" className="d-none d-xl-flex">
                                <VerticalDivider style={{height: "100%", margin: "0 auto"}}/>
                            </Col>
                            <Col>
                                <Row>
                                    <h5 className="h5">EQUIPMENT DETAILS</h5>
                                </Row>
                                <Row>
                                    <Col>
                                        <EquipmentType band={1} bandItem="" />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <EquipmentDetails band={1} bandItem="" />
                                    </Col>
                                </Row>
                                <Row>
                                    <h5 className="h5 mt-3">ANTENNA DETAILS</h5>
                                </Row>
                                <Row>
                                    <Col>
                                        <AntennaDetails band={1} bandItem="" />
                                    </Col>
                                </Row>
                                <Row>
                                    <h5 className="h5 mt-3">ADDITIONAL LOSSES <span style={{textTransform: "none"}}>(dB)</span></h5>
                                </Row>
                                <Row>
                                    <Col>
                                        <AdditionalLosses band={1} bandItem=""/>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="text-center">
                                <AccountContext.Consumer>
                                    {(acc) => (
                                    <SingleBandLinkUserContext.Consumer>
                                        {(link) => (
                                        <>
                                        <div className="d-grid gap-2 d-md-block col-6 mx-auto mt-4 mb-4">
                                            <Button className="menu-button" bsPrefix="" variant="secondary" onClick={() => {
                                                if(link.edit && link.isDualBandLink) {
                                                    this.setState({confirmSwitch: true})
                                                } else {
                                                    this.onSend(this.props.account.token, link, false)
                                                }
                                            }}>Save</Button>
                                            <Button className={link.edit ? "menu-button ms-2" : "hide-input"} bsPrefix="" variant="secondary" onClick={() => this.onSend(this.props.account.token, link, true)}>Save As</Button>
                                            {/*<Button className={link.edit ? "menu-button ms-2" : "hide-input"} bsPrefix="" variant="secondary" onClick={() => window.location.href = "/link/"+link?.link?.idLink+"/budget"}>Link budget</Button>*/}
                                            {/*<Button className={link.edit ? "menu-button ms-2" : "hide-input"} bsPrefix="" variant="secondary" onClick={() => window.location.href = "/link/"+link?.link?.idLink+"/boq"}>Link BoM</Button>*/}
                                        </div>
                                        <Modal show={this.state.confirmSwitch} onHide={() => this.setState({confirmSwitch: false})}>
                                            <Modal.Header closeButton>
                                            <Modal.Title>Change the link from dual to single band</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>Please click on "Confirm" button to switch</Modal.Body>
                                            <Modal.Footer>
                                            <Button variant="secondary" onClick={() => this.setState({confirmSwitch: false})}>
                                                Cancel
                                            </Button>
                                            <Button variant="primary" onClick={() => this.onSend(this.props.account.token, link, false)}>
                                                Confirm
                                            </Button>
                                            </Modal.Footer>
                                        </Modal>
                                        </>
                                        )}
                                    </SingleBandLinkUserContext.Consumer>
                                    )}
                                </AccountContext.Consumer>
                            </Col>
                        </Row>
                    </Container>
                </SingleBandLinkReferenceContext.Provider>
            </SingleBandLinkUserContext.Provider>
    </>
    }


}
/*
    <Link className={link.edit ? "ms-md-3" : "hide-input"} to={"/link/"+link?.link?.idLink+"/budget"}>Calculate</Link>
    <Link className={link.edit ? "ms-md-3" : "hide-input"} to={"/link/"+link?.link?.idLink+"/boq"}>View BoM</Link>
*/

/**
 * Dual band link form
 */
export class DualBandLinkForm extends React.Component<any,any> {

    constructor(props: { loadReferenceData: any, forwardedData: any, account?: Readonly<any>, linkId?: string, notify: any, missingParameters: any, successfulSaving: any, errorSaving: any, sdIsEnabled: any}) {
        super(props);

        this.state = {
            reference: {},
        }
    }

    componentDidMount(): void {
        this.props.loadReferenceData(this)
    }

    /**
     * Update the equipment in the reference data
     * @param accountToken Account's token to access to WLD API
     * @param linkRef Reference data
     * @param link Link that user has selected
     * @param newEquip New equipment data which has been selected
     * @param fromBandItem The data field which has caused the update
     * @param toBandItem The data field will be updated with the new received data
     */
    static updatedEquipments(accountToken: string, linkRef: any, link: any, newEquip: any, fromBandItem: string, toBandItem: string="") {
        console.log("updatedEquipments !!")
        console.log(newEquip)
        fetch(CONFIG.apiURI+"/references/dualband/mix/"+link?.equipNorms?.idEquipNorm+"/"+newEquip.idEquip, { 
            method: 'GET',
            mode: "cors",
            headers: {
                Accept: 'application/json',
                "token": accountToken
            }
        })
        .then((res) => res.json())
        .then((json) => {
            let cache = linkRef;

            if(toBandItem != "") {
                cache.equipNorms[link.equipNorms?.index]["equipments"+toBandItem] = json;
                linkRef.define("equipNorms", cache.equipNorms)
            }

            let currentSelectedEquip = DualBandLinkForm.getCurrentEquipment(json, link["equipType"+toBandItem])

            cache = link;
            cache["equipType"+toBandItem]["frequences"] = currentSelectedEquip["reference_frequencies"]
            cache["equipType"+fromBandItem]["frequences"] = currentSelectedEquip["its_frequencies"]

            link.define("equipType"+fromBandItem, cache["equipType"+fromBandItem]) // update available equipments for the new equipment which has been selected
        })
    }

    /**
     * Find the obj of the selected equipments to get all frequencies which are available
     * @param allMix all mix available
     * @param toBandItem selected equipment for the other band
     */
    static getCurrentEquipment(allMix: any, toEquip: any): any {
        var res = {}
        allMix.forEach((equip: any) => {
            if(equip["idEquip"] == toEquip["idEquip"]) {
                res = equip;
                return;
            }
        });
        return res;
    }

/**
 * Set the rain rate according to geographical coordinates
 * @param token 
 * @param linkInput 
 */
    setManualRainRate(token: string, linkInput: any){
        let comp = this;

        let formData = new FormData();
        
        try{
            if (linkInput.prop_accuracy == "advanced") {
                if (linkInput.site1_coords.longitude != undefined
                    && linkInput.site1_coords.longitude_direction != undefined
                    && linkInput.site1_coords.latitude != undefined
                    && linkInput.site1_coords.latitude_direction != undefined
                    && linkInput.site2_coords.longitude != undefined
                    && linkInput.site2_coords.longitude_direction != undefined
                    && linkInput.site2_coords.latitude != undefined
                    && linkInput.site2_coords.latitude_direction != undefined){                      

                    formData.append("site1_long", linkInput.site1_coords.longitude);
                    formData.append("site1_long_side", linkInput.site1_coords.longitude_direction);
                    formData.append("site1_lat", linkInput.site1_coords.latitude);
                    formData.append("site1_lat_side", linkInput.site1_coords.latitude_direction);

                    formData.append("site2_long", linkInput.site2_coords.longitude);
                    formData.append("site2_long_side", linkInput.site2_coords.longitude_direction);
                    formData.append("site2_lat", linkInput.site2_coords.latitude);
                    formData.append("site2_lat_side", linkInput.site2_coords.latitude_direction);
                    
                    formData.append("site_length", linkInput.site_length);
                    formData.append("prop_accuracy", linkInput.prop_accuracy);

                    formData.append("rainRateNorm", linkInput.rainRateNorm.idRainRateNorm);
                    formData.append("annualOutageNorm", linkInput.annualOutageNorm.idAnnualOut);
                    
                    if(linkInput.annualOutageNorm.idAnnualOut == 2) {
                        formData.append("avg_tmp", linkInput?.avg_tmp == null ? 0 : linkInput?.avg_tmp);
                        formData.append("tempUnit", linkInput?.tempUnit.idTempUnit);
                    }

                    formData.append('name', linkInput.edit ? linkInput.link.name : linkInput.name);
                    formData.append('site1', linkInput.site1);
                    formData.append('losses_site1', linkInput.losses_site1 != undefined ? linkInput.losses_site1 : 0);
                    formData.append('site2', linkInput.site2);
                    formData.append('losses_site2', linkInput.losses_site2 != undefined ? linkInput.losses_site2 : 0);
                    formData.append('linkType', "1"); // Simple link
                    formData.append('margin', linkInput.margin != undefined ? linkInput.margin : 0);
                    formData.append('distanceUnit', linkInput.distanceUnits.idDistUnit);
                    formData.append('equipAntennaSite1', linkInput.equipAntennaSite1.idAntenna);
                    formData.append('equipAntennaSite2', linkInput.equipAntennaSite2.idAntenna);
        
                    if(this.props.sdIsEnabled(linkInput, "")) {
                        formData.append('equipAntennaSite1Div', linkInput.equipAntennaSite1Div.idAntenna);
                        formData.append('equipAntennaSite2Div', linkInput.equipAntennaSite2Div.idAntenna);
                    }
        
                    formData.append('equipBandw', linkInput.equipBandw.idChannelBdw);
                    formData.append('equipConf', linkInput.equipConf.idConf);
                    formData.append('equipFreq', linkInput.equipFreq.idFreq);
                    formData.append('equipMod', linkInput.equipMod.idMod);
        
                    if(linkInput.features.includes("7")) {
                        formData.append('equipModMax', linkInput.equipModMax.idMod);
                    }
        
                    formData.append('equipNorm', linkInput.equipNorms.idEquipNorm);
                    formData.append('equipType', linkInput.equipType.idEquip);

                    let features = linkInput.features == undefined ? [] : linkInput.features;
                    for (let i = 0; i < linkInput.equipConf.features.length; i++) {
                        const e = linkInput.equipConf.features[i];
                        if(e.mandatory) {
                            if(!features.includes(e.idFeature.toString())) {
                                features.push(e.idFeature.toString());
                            }
                        }
                    }       
                    formData.append('features', features);
        
                    formData.append('rainOutagePred', linkInput.rainOutageNorm.idRainOutPred);
                    
                    formData.append('multipathOutagePreds', linkInput.multipathOutagePreds.idPropCond);
                    formData.append('multipathOutageNorm', linkInput.multipathOutageNorm.idMultiPathOutPred);
        
                    if(linkInput.tx_power != null) {
                        formData.append('tx_power', linkInput.tx_power);
                    }
               
                    if(linkInput.rainOutageNorm.idRainOutPred == 2) { // 2 is Crane
                        formData.append('craneZone', linkInput.craneZone.idCraneZone);
                    } else {
                        formData.append('rainRate', linkInput.rainRate.val);
        
                        fetch(CONFIG.apiURI+"/link/rainrate", { 
                            method: 'POST',
                            mode: "cors",
                            headers: {
                                Accept: 'application/json',
                                "token": token
                            },
                            body: formData
                        })
                        .then((res) => res.json())
                        .then((json) => {
                            if (json != null) {
                                let rainRate = {
                                    val : parseInt(json)
                                }
                                linkInput.define("rainRate", rainRate);
                            }
                        })
                    }                            
                }
            }
        }
        catch{

        }
    }

    /**
     * Send the data to server
     * @param token The token generated for the user
     * @param linkInput Data of the user has defined in the form
     */
    onSend(token: string, linkInput: any, saveAs: boolean) {
        let comp = this
        let formData = new FormData();

        try {
            formData.append("prop_accuracy", linkInput.prop_accuracy);
            if(linkInput.prop_accuracy == "advanced") {
                formData.append("site1_long", linkInput.site1_coords.longitude);
                formData.append("site1_long_side", linkInput.site1_coords.longitude_direction);
                formData.append("site1_lat", linkInput.site1_coords.latitude);
                formData.append("site1_lat_side", linkInput.site1_coords.latitude_direction);

                formData.append("site2_long", linkInput.site2_coords.longitude);
                formData.append("site2_long_side", linkInput.site2_coords.longitude_direction);
                formData.append("site2_lat", linkInput.site2_coords.latitude);
                formData.append("site2_lat_side", linkInput.site2_coords.latitude_direction);

                formData.append("fadefactor", linkInput.fadefactor != undefined ? linkInput.fadefactor : 0);

                if(linkInput.rainOutageNorm.idRainOutPred == 1) {
                    if(linkInput.rainRateNorm.idRainRateNorm == null) {
                        throw new Error("Rain rate standard must be selected !")
                    }
                }

                formData.append("rainRateNorm", linkInput.rainRateNorm.idRainRateNorm);
                formData.append("annualOutageNorm", linkInput.annualOutageNorm.idAnnualOut);
                
                if(linkInput.annualOutageNorm.idAnnualOut == 2) {
                    formData.append("avg_tmp", linkInput?.avg_tmp == null ? 0 : linkInput?.avg_tmp);
                    formData.append("tempUnit", linkInput?.tempUnit.idTempUnit);
                } else if (linkInput.annualOutageNorm.idAnnualOut == null) {
                    throw new Error("Annual outages methodology must be selected !")
                }
            }

            if((linkInput?.edit && linkInput?.link?.name?.length == 0) || linkInput?.name?.length == 0) {
                alert("Please, define a name for your configuration !");
                return;
            }
            
            formData.append('name', linkInput.edit ? linkInput.link.name : linkInput.name);
            formData.append('site_length', (Math.round(linkInput.site_length * 100) / 100).toString());
            formData.append('site1', linkInput.site1);
            formData.append('losses_site1', linkInput.losses_site1 != undefined ? linkInput.losses_site1 : 0);
            formData.append('site2', linkInput.site2);
            formData.append('losses_site2', linkInput.losses_site2 != undefined ? linkInput.losses_site2 : 0);
            formData.append('linkType', "1"); // Simple link
            formData.append('margin', linkInput.margin != undefined ? linkInput.margin : 0);
            formData.append('distanceUnit', linkInput.distanceUnits.idDistUnit);


            if(linkInput.showDualBandAntenna && this.dualBandAntennaIsAvailable(linkInput)) {
                formData.append('equipDualBandAntenna', linkInput.equipDualBandAntenna.idAntenna);
            } else {
                // first band's antennas
                formData.append('equipAntennaSite1', linkInput.equipAntennaSite1.idAntenna);
                formData.append('equipAntennaSite2', linkInput.equipAntennaSite2.idAntenna);

                // second band's antennas
                formData.append('equipAntennaSite12', linkInput.equipAntennaSite12.idAntenna);
                formData.append('equipAntennaSite22', linkInput.equipAntennaSite22.idAntenna);
            }
           /*if(this.props.sdIsEnabled(linkInput, "")) {
                formData.append('equipAntennaSite1Div', linkInput.equipAntennaSite1Div.idAntenna);
                formData.append('equipAntennaSite2Div', linkInput.equipAntennaSite2Div.idAntenna);
            }*/

            // First band
            formData.append('equipType', linkInput.equipType.idEquip);
            formData.append('equipBandw', linkInput.equipBandw.idChannelBdw);
            formData.append('equipConf', linkInput.equipConf.idConf);
            formData.append('equipFreq', linkInput.equipFreq.idFreq);
            formData.append('equipMod', linkInput.equipMod.idMod);

            if(linkInput.features.includes("7")) {
                formData.append('equipModMax', linkInput.equipModMax.idMod);
            }

            let features = linkInput.features == undefined ? [] : linkInput.features;
            for (let i = 0; i < linkInput.equipConf.features.length; i++) {
                const e = linkInput.equipConf.features[i];
                if(e.mandatory) {
                    if(!features.includes(e.idFeature.toString())) {
                        features.push(e.idFeature.toString());
                    }
                }
            }

            // Check if required features are selected
            if(!(features.includes("1") || features.includes("2"))) {
                alert("Please, select a polarization !");
                throw "Erreur !";
            } else if(!(features.includes("5") || features.includes("6"))) {
                alert("Please, select a polarization !");
                throw "Erreur !";
            }

            formData.append('features', features);

            // Second band
            formData.append('equipType2', linkInput.equipType2.idEquip);
            formData.append('equipBandw2', linkInput.equipBandw2.idChannelBdw);
            formData.append('equipConf2', linkInput.equipConf2.idConf);
            formData.append('equipFreq2', linkInput.equipFreq2.idFreq);
            formData.append('equipMod2', linkInput.equipMod2.idMod);

            if(linkInput.features2.includes("7")) {
                formData.append('equipModMax2', linkInput.equipModMax2.idMod);
            }

            let features2 = linkInput.features2 == undefined ? [] : linkInput.features2;
            for (let i = 0; i < linkInput.equipConf2.features.length; i++) {
                const e = linkInput.equipConf2.features[i];
                if(e.mandatory) {
                    if(!features2.includes(e.idFeature.toString())) {
                        features2.push(e.idFeature.toString());
                    }
                }
            }

            // Check if required features are selected
            if(!(features2.includes("1") || features2.includes("2"))) {
                alert("Please, select a polarization !");
                throw "Erreur !";
            } else if(!(features2.includes("5") || features2.includes("6"))) {
                alert("Please, select a polarization !");
                throw "Erreur !";
            }

            formData.append('features2', features2);

            formData.append('equipNorm', linkInput.equipNorms.idEquipNorm);

            if(linkInput?.prop_accuracy == "advanced") {
                let valid = false;
                if(!(linkInput?.site1_coords?.latitude_direction == "S" || linkInput?.site1_coords?.latitude_direction == "N")) {
                    alert("Longitude site 1 is invalid !");
                    throw "Erreur !";
                }

                if(!(linkInput?.site2_coords?.latitude_direction == "S" || linkInput?.site2_coords?.latitude_direction == "N")) {
                    alert("Longitude site 2 is invalid !");
                    throw "Erreur !";
                }

                if(!(linkInput?.site1_coords?.longitude_direction == "E" || linkInput?.site1_coords?.longitude_direction == "W")) {
                    alert("Latitude site 1 is invalid !");
                    throw "Erreur !";
                }

                if(!(linkInput?.site2_coords?.longitude_direction == "E" || linkInput?.site2_coords?.longitude_direction == "W")) {
                    alert("Latitude site 2 is invalid !");
                    throw "Erreur !";
                }

                if(!REGEX_DEGREE_COORDS.test(linkInput?.site1_coords?.longitude)) {
                    alert("The coordinates of the site 1 are invalid !");
                    throw "Erreur !";
                }

                if(!REGEX_DEGREE_COORDS.test(linkInput?.site2_coords?.longitude)) {
                    alert("The coordinates of the site 2 are invalid !");
                    throw "Erreur !";
                }
            }


            if(linkInput.rainOutageNorm.idRainOutPred == 2) { // 2 is Crane
                formData.append('craneZone', linkInput.craneZone.idCraneZone);
            } else {
                if(linkInput.rainRate.val == 0 || linkInput.rainRate.val == null) {
                    throw new Error("Rain rate must be upper than 0 !")
                }
                formData.append('rainRate', linkInput.rainRate.val);
            }

            if(linkInput.rainOutageNorm.idRainOutPred == null) {
                throw new Error("Rain rate standard must be selected !")
            }

            formData.append('rainOutageNorm', linkInput.rainOutageNorm.idRainOutPred);
            
            formData.append('multipathOutagePreds', linkInput.multipathOutagePreds.idPropCond);
            formData.append('multipathOutageNorm', linkInput.multipathOutageNorm.idMultiPathOutPred);

            if(linkInput.tx_power != null) {
                formData.append('tx_power', linkInput.tx_power);
            }

            if(linkInput.tx_power2 != null) {
                formData.append('tx_power2', linkInput.tx_power2);
            }

            // if a single band link switch to a dual band link then true else false
            let replace = (linkInput.edit && (!linkInput.isDualBandLink || linkInput.isDualBandLink == null) && saveAs == false)
        
            let url = CONFIG.apiURI+"/link"
            if(replace) {
                fetch(CONFIG.apiURI+"/link/dualband/"+linkInput.link.idLink,
                { 
                    method: 'POST',
                    mode: "cors",
                    headers: {
                        Accept: 'application/json',
                        "token": token
                    },
                    body: formData
                }
                ).then((response) => response.json())
                .then((data) => {
                    comp.props.successfulSaving();
                    linkInput.define('link', {
                        idLink: data.idLink,
                        lastUpdate: data.lastUpdate,
                        name: data.name
                    });
                    linkInput.define('edit', true);     
                })
                .catch((error) => {
                    comp.props.errorSaving();
                });
                
                return;

            } else if(linkInput.edit && saveAs == false) {
                url = url + "/" + linkInput.link.idLink
            } else {
                url = url + "/dualband"
            }

            comp.props.notify();
            fetch(url,
            { 
                method: 'POST',
                mode: "cors",
                headers: {
                    Accept: 'application/json',
                    "token": token
                },
                body: formData
            }
            ).then((response) => response.json())
            .then((data) => {
                comp.props.successfulSaving();
                linkInput.define('link', {
                    idLink: data.idLink,
                    lastUpdate: data.lastUpdate,
                    name: data.name
                });
                linkInput.define('edit', true);
                window.history.replaceState('', '', saveAs == true ? "/link/"+data.idLink : "/link/"+linkInput.link.idLink);
            })
            .catch((error) => {
                comp.props.errorSaving();
            });
        } catch(e: any) {
            if(e.message.includes("is undefined")) { // if the error is a default message
                comp.props.missingParameters()
            } else {
                comp.props.missingParameters(e.message)
            }
        }

    }

    /**
     * Check if there is at least 1 dual band antenna
     * @returns true or false
     */
    dualBandAntennaIsAvailable(link: any) {

        if(link == undefined)
            return false;

        return (link.dualBandAntennas != null && link.dualBandAntennas.length > 0) || (link.edit && link.equipDualBandAntenna != null)
    }

    render() {
        return <>
        <DualBandLinkUserContext.Provider value={this.props.forwardedData == undefined ? {} : this.props.forwardedData}>
                <DualBandLinkReferenceContext.Provider value={this.state.reference}>
                    <Container className='mt-3'>
                        <Row>
                            <Col>
                                <Row>
                                    <h5 className="h5">GENERAL</h5>
                                </Row>
                                <Row>
                                    <Col>
                                        <Standard band={2}></Standard>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <LinkName band={2}></LinkName>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <PropagationAccuracy band={2}/>
                                    </Col>
                                </Row>
                                <Row>
                                
                                    <h5 className="h5 mt-3">PROPAGATION CONDITIONS</h5>
                                    <MultiPathOutage band={2}/>
                                </Row>
                            </Col>
                            <Col xs lg="1" className="d-none d-xl-flex">
                                <VerticalDivider style={{height: "100%", margin: "0 auto", opacity: 0}}/>
                            </Col>
                            <Col>
                                <Container>
                                        <DualBandLinkUserContext.Consumer>
                                        {(link) => (
                                        <>
                                            <Row>
                                                <h5 className="h5 mt-3">SITES</h5>
                                                <div>
                                                    { this.props.forwardedData?.prop_accuracy == "advanced" ? <AdvancedPathDetail band={2} onChange={() => this.setManualRainRate(this.props.account.token, link)}/> : <PathDetails band={2}/>}
                                                </div>                                    
                                            </Row>
                                            <Row>
                                                <h5 className="h5 mt-3">RAIN OUTAGE PREDICTIONS</h5>
                                                <RainOutagePred band={2}/>
                                                { this.props.forwardedData?.prop_accuracy == "advanced" ?
                                                <>
                                                <h5 className="h5 mt-3">ANNUAL OUTAGES</h5>
                                                <AnnualOutage band={2}/> 
                                                </> 
                                                : 
                                                <></> }
                                            </Row>
                                        </>
                                        )}
                                        </DualBandLinkUserContext.Consumer>
                                </Container>
                            </Col>
                        </Row>
                        <Row>
                            <h5 className="h5 mt-5 mb-4 text-center">EQUIPMENT DETAILS</h5>
                        </Row>
                        <Row>
                            <Col>
                                <h5 className="h5 mt-3">Band 1</h5>
                                <Row>
                                    <EquipmentType band={2} bandItem="" linkForm={this} />
                                </Row>
                                <Row>
                                    <Container>
                                        <EquipmentDetails band={2} bandItem="" />
                                    </Container>
                                </Row>
                            </Col>
                            <Col xs lg="1" className="d-none d-xl-flex">
                                <VerticalDivider style={{height: "100%", margin: "0 auto"}}/>
                            </Col>
                            <Col>
                            <h5 className="h5 mt-3">Band 2</h5>
                                <Row>
                                    <EquipmentType band={2} bandItem="2" />
                                </Row>
                                <Row>
                                    <Container>
                                        <EquipmentDetails band={2} bandItem="2" />
                                    </Container>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Row>
                                    <h5 className="h5 mt-5 mb-4 text-center">ANTENNA DETAILS</h5>
                                </Row>
                                { this.dualBandAntennaIsAvailable(this.props.forwardedData) ?
                                    <Row>
                                        <Col></Col>
                                        <Col sm={6} md={3}>
                                            <Form.Check // prettier-ignore
                                                type="switch"
                                                id="switch-dualband-antenna"
                                                value={this.props.forwardedData?.showDualBandAntenna}
                                                checked={this.props.forwardedData?.showDualBandAntenna}
                                                label="Enable a dual band antenna"
                                                onChange={() => this.props.forwardedData?.define("showDualBandAntenna", !this.props.forwardedData?.showDualBandAntenna)}
                                            />
                                        </Col>
                                        <Col></Col>
                                    </Row>
                                :
                                    <></>
                                }
                                { this.props.forwardedData?.showDualBandAntenna && this.dualBandAntennaIsAvailable(this.props.forwardedData) ?
                                
                                    <>
                                        <Row>
                                            <Col></Col>
                                            <Col sm={8} md={4}>
                                                <DualBandAntennaDetails/>
                                            </Col>
                                            <Col></Col>
                                        </Row>
                                    </>
                            
                                    :

                                    <Row>    
                                        <Col>
                                            <AntennaDetails band={2} bandItem=""/>
                                        </Col>
                                        <Col xs lg="1" className="d-none d-xl-flex">
                                            <VerticalDivider style={{height: "100%", margin: "0 auto"}}/>
                                        </Col>
                                        <Col>
                                            <AntennaDetails band={2} bandItem="2"/>
                                        </Col>
                                    </Row>
                                }
                                <Row>
                                    <h5 className="h5 mt-5 mb-4 text-center">ADDITIONAL LOSSES <span style={{textTransform: "none"}}>(dB)</span></h5>
                                </Row>
                                <Row>
                                    <AdditionalLosses band={2}/>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="text-center">
                                <AccountContext.Consumer>
                                    {(acc) => (
                                        <>
                                        <div className="d-grid gap-2 d-md-block col-6 mx-auto mt-4 mb-4">
                                            <Button className="menu-button" bsPrefix="" variant="secondary" onClick={() => this.onSend(this.props.account.token, this.props.forwardedData, false)}>Save</Button>
                                            <Button className={this.props.forwardedData?.edit ? "menu-button ms-2" : "hide-input"} bsPrefix="" variant="secondary" onClick={() => this.onSend(this.props.account.token, this.props.forwardedData, true)}>Save As</Button>
                                            {/*<Button className={this.props.forwardedData?.edit ? "menu-button ms-2" : "hide-input"} bsPrefix="" variant="secondary" onClick={() => window.location.href = "/link/"+this.props.forwardedData?.link?.idLink+"/budget"}>Link budget</Button>*/}
                                            {/*<Button className={this.props.forwardedData?.edit ? "menu-button ms-2" : "hide-input"} bsPrefix="" variant="secondary" onClick={() => window.location.href = "/link/"+this.props.forwardedData?.link?.idLink+"/boq"}>Link BoM</Button>*/}
                                        </div>
                                        </>
                                    )}
                                </AccountContext.Consumer>
                            </Col>
                        </Row>
                    </Container>
                </DualBandLinkReferenceContext.Provider>
        </DualBandLinkUserContext.Provider>
    </>
    }

// <Link className={this.props.forwardedData?.edit ? "ms-md-3" : "hide-input"} to={"/link/"+this.props.forwardedData?.link?.idLink+"/budget"}>Calculate</Link>
}